import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  type LauncherPlacement,
  normalizeLauncherPlacement,
} from '../components/placement/launcherPlacement';

export interface JotSupportPlacementState {
  placement: LauncherPlacement | null;
}

const initialState: JotSupportPlacementState = { placement: null };

const placementSlice = createSlice({
  name: 'jotSupport',
  initialState,
  reducers: {
    setPlacement(state, action: PayloadAction<LauncherPlacement>) {
      const placement = normalizeLauncherPlacement(action.payload);
      if (placement) state.placement = placement;
    },
    resetPlacement: () => initialState,
  },
});

export const { setPlacement, resetPlacement } = placementSlice.actions;
export default placementSlice.reducer;
